import isClient from "./isClient";

export default function isDesktop() {
  if (!isClient()) return
  return !!window.matchMedia("screen and (min-width:1024px)").matches
}
